var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEosIconsPipeline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 15V16.6666H8.33317V6.66665H9.99984V3.33331H1.6665V6.66665H3.33317V18.3333C3.33317 19.2174 3.68436 20.0652 4.30948 20.6903C4.9346 21.3155 5.78245 21.6666 6.6665 21.6666H14.9998V23.3333H18.3332V15H14.9998ZM36.6665 33.3333V20C36.6665 19.1159 36.3153 18.2681 35.6902 17.643C35.0651 17.0178 34.2172 16.6666 33.3332 16.6666H24.9998V15H21.6665V23.3333H24.9998V21.6666H31.6665V33.3333H29.9998V36.6666H38.3332V33.3333H36.6665Z",
    fill: "#0D99FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEosIconsPipeline);
export default __webpack_public_path__ + "static/media/eos-icons_pipeline.70f0c9a0070393dc6c00d99d45b6a64f.svg";
export { ForwardRef as ReactComponent };